export default __webpack_public_path__ + "static/shape_diamond-c7de6ed39a08a44e481f8f29de7e4ca2.png";